import cn from 'classnames';

import Spinner from './Spinner';



interface LoaderProps {
    withSpinner?: boolean;
    solidBackdrop?: boolean;
}

export default function Loader({withSpinner, solidBackdrop}: LoaderProps) {
    return (
        <div className={cn('loader__backdrop', solidBackdrop && 'loader__backdrop--solid')}>
            {withSpinner && <Spinner/>}
        </div>
    );
}
